const ExtractShortNameFromIncidentFriendlyContainer = (friendlyContainer:string, length:number):string => {

    return friendlyContainer.length > length ? 
        friendlyContainer.substring(0, length) + '...' : 
        friendlyContainer
}

export default ExtractShortNameFromIncidentFriendlyContainer